import {
  DeesElement,
  css,
  cssManager,
  customElement,
  html,
  property,
  type CSSResult,
  type TemplateResult,
} from '@design.estate/dees-element';

import * as domtools from '@design.estate/dees-domtools';
import { demoFunc } from './dees-badge.demo.js';
import { themeDefaultStyles } from '../../00theme.js';

declare global {
  interface HTMLElementTagNameMap {
    'dees-badge': DeesBadge;
  }
}

@customElement('dees-badge')
export class DeesBadge extends DeesElement {
  public static demo = demoFunc;
  public static demoGroups = ['Feedback'];

  @property({ type: String })
  accessor type: 'default' | 'primary' | 'success' | 'warning' | 'error' = 'default';

  @property({ type: String })
  accessor text: string = '';

  @property({ type: Boolean })
  accessor rounded: boolean = false;

  constructor() {
    super();
    domtools.elementBasic.setup();
  }

  public static styles = [
    themeDefaultStyles,
    cssManager.defaultStyles,
    css`
      :host {
        display: inline-block;
        font-family: var(--dees-font-family);
      }

      .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 2px var(--dees-spacing-sm);
        font-size: var(--dees-font-caption1-size);
        font-weight: var(--dees-font-control-weight);
        line-height: var(--dees-font-caption1-line);
        border-radius: var(--dees-radius-md);
        white-space: nowrap;
      }

      .badge.rounded {
        border-radius: var(--dees-radius-full);
      }

      .badge.default {
        background: var(--dees-color-badge-default-bg);
        color: var(--dees-color-badge-default-fg);
      }

      .badge.primary {
        background: color-mix(in srgb, var(--dees-color-accent-primary) 14%, transparent);
        color: var(--dees-color-accent-primary);
      }

      .badge.success {
        background: var(--dees-color-badge-success-bg);
        color: var(--dees-color-badge-success-fg);
      }

      .badge.warning {
        background: var(--dees-color-badge-warning-bg);
        color: var(--dees-color-badge-warning-fg);
      }

      .badge.error {
        background: var(--dees-color-badge-error-bg);
        color: var(--dees-color-badge-error-fg);
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <div class="badge ${this.type} ${this.rounded ? 'rounded' : ''}">
        ${this.text}
      </div>
    `;
  }
}
